import * as THREE from "three";
import * as CONFIG from './config';
import {aircraftConfig} from "../../config";
import {glbLoader} from "../three/glbloader";

export function initEmptyCockpit(){

    return {
        panels: {},
        materials: CONFIG.materials,
        screens: []
    };
}

export async function load(aircraft, materials) {

    let file, mesh

    let mainPanels = require("@/assets/airplanes/" + aircraft + "/01_json/MainPanels.json");

    let itemMesh = await glbLoader(aircraftConfig.getMeshPath('item'));
    itemMesh.material = new THREE.MeshNormalMaterial();

    let itemBorder = await glbLoader(aircraftConfig.getMeshPath('item_border'));
    itemBorder.material = materials.materialBorder; //load Box Mesh

    const panels = {};

    //Panels Border
    for (let panel in mainPanels) {

        if(!mainPanels.hasOwnProperty(panel)) continue;

        panels[panel] = {}

        //Panel Border
        file = aircraftConfig.getMeshPath(mainPanels[panel].id); //set path to Mesh File
        mesh = await glbLoader(file);
        mesh = setPanelPosition(mesh, mainPanels[panel]);
        mesh.name = mainPanels[panel].id + "-Border";
        mesh.material = materials.panelsBorder;
        panels[panel].meshBorder = mesh

        //Panel Full
        file = aircraftConfig.getMeshPath(mainPanels[panel].id + '_full'); //set path to Mesh File
        mesh = await glbLoader(file);
        mesh = setPanelPosition(mesh, mainPanels[panel]);
        mesh.name = mainPanels[panel].id + "-Full";
        mesh.material = materials.panelsFull;
        panels[panel].meshFull = mesh

        //Panel Titel
        file = aircraftConfig.getMeshPath(mainPanels[panel].id + '_title'); //set path to Mesh File
        mesh = await glbLoader(file);
        //mesh = setPanelPosition(mesh, mainPanels[panel]);
        mesh.name = mainPanels[panel].id + "-Title";
        mesh.material = materials.title;
        panels[panel].meshTitle = mesh

        //Items
        panels[panel].items = {}
        let items = await require("../../assets/airplanes/" + aircraft + "/01_json/" + mainPanels[panel].id + ".json");
        for (let element in items) {
            if(!items.hasOwnProperty(element)) continue;
            panels[panel].items[element] = items[element]
        }
    }

    //console.log(cockpit)
    return panels;
}

//-----------------------------------------------------
//--- C O N S T R U C T O R ----- F U N C T I O N S ---
//-----------------------------------------------------


function setPanelPosition(mesh, panel) {
    //mesh.geometry.center();
    let positionX = mesh.position.x + panel.main.positionAddX;
    let positionY = mesh.position.y + panel.main.positionAddY;
    let positionZ = mesh.position.z + panel.main.positionAddZ;
    mesh.position.set(positionX, positionY, positionZ); // Position Mesh Panel
    let scaleX = mesh.scale.x + panel.main.scaleAddX;
    let scaleY = mesh.scale.y + panel.main.scaleAddY;
    let scaleZ = mesh.scale.z + panel.main.scaleAddZ;
    mesh.scale.set(scaleX, scaleY, scaleZ); // Scale Mesh Panel
    let rotationX = mesh.rotation.x + panel.main.rotationAddX;
    let rotationY = mesh.rotation.y + panel.main.rotationAddY;
    let rotationZ = mesh.rotation.z + panel.main.rotationAddZ;
    mesh.rotation.set(rotationX, rotationY, rotationZ);
    mesh.name = panel.id;
    return mesh;
}

function loadPanelMeshs() {
    let panelPromises = [];
    for (let key in cockpit.panels) {
        let filename = cockpit.panels[key].id; //get name of panel 
        cockpit.panels[filename].group = new THREE.Group();
        let file
        file = aircraftConfig.getMeshPath(filename); //set path to Mesh File
        panelPromises.push(glbLoader(file, filename, 'border')); //call glbLoader to fetch Panel Mesh
        file = aircraftConfig.getMeshPath(filename + '_full'); //set path to Mesh File
        panelPromises.push(glbLoader(file, filename, 'full')); //call glbLoader to fetch Panel Mesh
    }
    return Promise.all(panelPromises);
}
